import { useSelector } from 'react-redux';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import * as lenderListSelectors from '@makemydeal/dr-dash-store/selectors/lenderListSelectors';
import * as lenderAddressSelectors from '@makemydeal/dr-dash-store/selectors/lenderAddressSelectors';
import { appendHardcodedContractingLenders } from '../terms/common/hardcodedContractingLenders';
import { useIsDealLocked } from './useDealLockStatus';

export const useIsLenderFieldDisabled = (): boolean => {
    const lenderList = useSelector(lenderListSelectors.getLenderList);
    const isFordLincolnLendersEnabled = useSelector(featureToggleSelectors.isFordLincolnLendersEnabled);
    const isLenderAddressLoading = useSelector(lenderAddressSelectors.getIsLenderAddressLoading);
    const lenderDecisions = isFordLincolnLendersEnabled ? appendHardcodedContractingLenders(lenderList) : lenderList;
    const isLocked = useIsDealLocked();

    return isLocked || !lenderDecisions.length || isLenderAddressLoading;
};
